import InstanceListPage from '../components/InstanceListPage/InstanceListPage';
import { InstanceListType } from '../utils/models';

export default function AdminInstancePage() {
  return <InstanceListPage type={InstanceListType.admin} />;
}
